<template>
    <div>
      <div style="background-color: #fff;">
        <div style="height: 80px; background-color: #1680ff; padding-top: 20px;">
        <!-- 1. 顶部区域 -->
          <div class="contain ">
            <img src="../assets/logo-fff.png" alt="Logo" style="max-height: 100%;">
            <div class="user" v-if="user">欢迎你，<router-link :to="{ name: 'AppResourceMy'}">{{user.username}}</router-link><span @click="logout">退出</span></div>
            <div class="search-header" @click="show=true">
              <el-input placeholder="请输入内容" readonly >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            
          </div>
        </div>
      </div>

        <!-- 2. 菜单 -->
        <div class="menu">
          <div class="contain">
          <el-menu :default-active="active" background-color="#fff" text-color="#000" active-text-color="#1680ff" class="content-wrapper" mode="horizontal" @select="handleMenuSelect">
            <el-menu-item :index="item.id" v-for="item in menus">{{item.name}}</el-menu-item>
            
          </el-menu>
        </div>
        </div>
        <!-- 3. Banner 图片 -->
        <div class="banner" v-show="showBanner" style=" display: flex; justify-content: center; align-items: center;">
          <img src="../assets/banner.jpg" alt="Banner" style="max-width: 100%; max-height: 100%;">
        </div>

        <el-dialog title="搜索" width="60%" :visible.sync="show">
          <el-input placeholder="请输入内容" v-model="keyword" class="input-with-input">
            <el-select v-model="type" slot="prepend" placeholder="请选择" class="input-with-select">
              <el-option label="文章" value="1"></el-option>
              <el-option label="资源" value="2"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="searchDo"></el-button>
          </el-input>
          <div class="listBox">
            <ul class="article" v-if="list && list.total>0">
              <li v-for="item in list.data"><router-link :to="{ name: 'ArticleInfo', params: {id: item.id}, query: {nav_id: navId}}"><span class="tit">{{item.title}}</span></router-link></li>
            </ul>
            <p v-else style="text-align: center; margin: 20px;">暂无内容</p>
          </div>
        </el-dialog>

        
      </div>
</template>
<script>
import { removeToken } from '@/utils/auth'
import { article } from '@/api/index'
export default {
  data() {
    return {
      user: this.$store.state.user,
      active: '0',
      showBanner: true,
      keyword: '',
      type: '1',
      list: null,
      show: false,
      menus: [
        {
          name: '首页',
          id: '0'
        },
        {
          name: '教育动态',
          id: '2'
        },
        {
          name: '通知公告',
          id: '1'
        },
        {
          name: '制度汇编',
          id: '3'
        },
        {
          name: '资源中心',
          id: '100'
        },
        {
          name: '学科教研方案',
          id: '4'
        },
        {
          name: '校园活动方案',
          id: '5'
        },
        {
          name: '校报校刊方案',
          id: '6'
        }
        
      ]
    };
  },
  // props: {
  //   active: {
  //     type: String,
  //     default: '0'
  //   }
  // },
  watch: {
    active: function(val){
      this.activeMenu = val
    }
  },
  components: {
    
  },
  created(){
    this.showBanner = this.$route.meta.showBanner
    if(this.$route.query.nav_id>0)this.active = this.$route.query.nav_id
  },
  methods: {
    handleMenuSelect(index) {
      let name = 'Article'
      if(index == 100) {
        name = 'Res'
      }else if(index == 0) {
        name = 'Index'
      }
      this.$router.push({'name': name, query: {nav_id: index}})
    },
    logout(){
      this.$confirm('你确定要退出吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              removeToken()
              this.$router.push({name: 'Login'})
            }).catch(() => {
              
            })
      
    },
    searchDo(){
      if(this.type == 1) {
        article({title: this.keyword}).then(res=> {
          this.list = res.list
        })
      }else if(this.type == 2) {
        this.$router.push({name: 'Res', query: {title: this.keyword, nav_id: 100}})
      }
    }
  },
};
</script>

<style scoped>

.menu {
  margin-top: 0px;
  background-color: #fff;
}
.menu .el-menu.el-menu--horizontal {
    border-bottom: 0px;
}
.is-active{
  background-color: #fff!important;
}
.el-menu--horizontal>.el-menu-item{
  height: 50px;
  line-height: 50px;
}
.user{
  float: right;
  cursor: pointer;
  margin-top: 15px;
  color: #fff;
}
.search-header{
  float: right;
  width: 200px;
  margin: 15px 120px 20px 20px;
}

.user a{
  color: #fff;
}
.user span{
  margin-left: 10px;
  color: red;
}
.input-with-select{
  width: 100px;
}
.listBox{
  height: 300px;
  overflow-y: scroll;
}
.article{
  margin: 20px;
}
</style>
<style>
.search-header .el-input__inner{
  height: 35px;
  font-size: 12px;
}
</style>